"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadsDatepicker = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../shared/core");
var components_1 = require("../../../shared/core/components");
var MeterReadingsContext_1 = require("../MeterReadingsContext");
var copy_1 = require("../copy");
var utils_1 = require("../utils");
var MeterReadsDatepicker = function (_a) {
    var _b;
    var id = _a.id, supplyStartDate = _a.supplyStartDate, setDate = _a.setDate, fuel = _a.fuel, error = _a.error;
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    var readings = (0, react_1.useContext)(MeterReadingsContext_1.MeterReadingsContext).readings;
    var onChange = function (date) {
        var parsedDate = date.trim();
        setDate(parsedDate);
    };
    // pick latest of following as oldest date for which we can submit a meter reading
    // 1. today - 9 days
    // 2. supply start date
    // 3. day meter installed (MEx event)
    var now = (0, date_fns_1.startOfToday)();
    var tenDaysAgo = (0, date_fns_1.subDays)(now, 9);
    var lastMexDate = (_b = (0, utils_1.getLatestMeterExchangeReading)(readings[fuel])) === null || _b === void 0 ? void 0 : _b.readingDateTime;
    var minDate = (0, date_fns_1.isAfter)(tenDaysAgo, supplyStartDate)
        ? tenDaysAgo
        : supplyStartDate;
    if (lastMexDate && (0, date_fns_1.isAfter)(lastMexDate, minDate)) {
        minDate = lastMexDate;
    }
    return (react_1.default.createElement(components_1.DatepickerField, { id: id, label: copy('readingDateLabel'), error: error, hint: copy('readingDateHint'), defaultValue: "Today", onChange: onChange, isDateUnavailable: function (date) {
            return (0, date_fns_1.isBefore)(date.toString(), minDate) ||
                (0, date_fns_1.isAfter)(date.toString(), (0, date_fns_1.startOfToday)());
        } }));
};
exports.MeterReadsDatepicker = MeterReadsDatepicker;
